import {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import useSubscriptionStatus from 'src/hooks/userSubscriptionStatus';

const RequireSubscription = ({ children }) => {
  const navigate = useNavigate();
  const { subscriptionActive, loading } = useSubscriptionStatus();

  useEffect(() => {
    if (!subscriptionActive && loading === false) {
      navigate('/app/management/settings');
    }
  }, [subscriptionActive, loading, navigate]);

  if (loading) {
    return (
      <Box minHeight="40vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress size={28} />
      </Box>
    );
  }

  return subscriptionActive ? children : null;
};

export default RequireSubscription;
